import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from 'src/app/i18n';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { CustomSelectSearchComponent } from '../../select-search/custom-select-search.component';
import { SelectionListModule } from '../base/selection-list/selection-list.module';
import { PhonebookSelectionList } from './phonebook-selection-list.component';

@NgModule({
  declarations: [
    PhonebookSelectionList
  ],
  imports: [
    CommonModule,
    SelectionListModule,
    TranslationModule,
    MaterialModule,
    CustomSelectSearchComponent,
  ],
  exports: [
    PhonebookSelectionList
  ]
})
export class PhonebookSelectionListModule { }
